module.exports = __webpack_public_path__ + "img/322.bceac7b9.jpg";